import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BannersService {

  constructor(private http: HttpClient) { }

  

  getBannerRandom(dataIn) {
    
    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.BANNER.GET_BANNER_RANDOM +  '/' + dataIn.catalogueId + '/banners/random';

    return this.http.get(url, dataIn);
  }


}
